"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnCallScheduleNoOneOnDutyActionValues = exports.OnCallScheduleNoOneOnDutyAction = void 0;
var OnCallScheduleNoOneOnDutyAction;
(function (OnCallScheduleNoOneOnDutyAction) {
    OnCallScheduleNoOneOnDutyAction["DO_NOTHING"] = "DO_NOTHING";
    OnCallScheduleNoOneOnDutyAction["IMMEDIATELY_SKIP_TO_THE_NEXT_STEP"] = "IMMEDIATELY_SKIP_TO_THE_NEXT_STEP";
})(OnCallScheduleNoOneOnDutyAction = exports.OnCallScheduleNoOneOnDutyAction || (exports.OnCallScheduleNoOneOnDutyAction = {}));
exports.OnCallScheduleNoOneOnDutyActionValues = Object.values(OnCallScheduleNoOneOnDutyAction);
